export const light = "#ffffff";
export const dark = "#000000";

export const text = "#869BB5";
export const muted = "rgba(68, 86, 107, 0.75)";
export const extraMuted = "rgba(96, 113, 123, 0.20)";

export const primary = "#2ac7dc";
export const primaryBright = "#2ac7dc";
export const accent = "#FF5841";

export const success = "limegreen";
export const error = "crimson";

export const mailBlue = "#0068C6";

// homepage v5 update
export const primaryButtonColor = "#FF5841";
export const primaryButtonTextColor = "#FFFFFFFC";

export const secondaryText = "#687782";

export const darkThemeColor = "#0C0F14";

export const footerInputBackround = "#181D24";

export const whiteLightColor = "rgba(255, 255, 255, 0.8)";

export const dimmedLight = "#C9DAE8";

export const dimmedGrey = "#8E9DA8";

export const blueGradient =
  "radial-gradient(117.29% 1278% at 107.91% 94.25%, #0068C6 0%, #82FCFF 100%)";

export const gradientTriad =
  "radial-gradient(117.29% 1278% at 107.91% 94.25%, #FF5841 0%, #0068C6 23.1%, #8CE3E6 100%)";

export const ctaGradientBlue =
  "radial-gradient(341.27% 339.58% at 68.67% 225.93%, #0068C6 13.41%, #8CE3E6 71.73%)";

export const ctaGradientBlueFocus =
  "radial-gradient(341.27% 339.58% at 68.67% 225.93%, #0068C6 13.41%, #00f9ff 71.73%)";

export const backgroundNavItem = "rgba(24, 29, 36, 0.7)";

export const primaryGreen = "#6AD1E4";

export const dimmedCalm = "#E685AE";

export const calm = "#F3509E";

export const calmGradient =
  "radial-gradient(84.38% 918.39% at 107.91% 94.25%, #C8397D 0%, #E888B0 100%)";

export const calmExtraLight = "#FFE9F3";

export const transparent = "transparent";
